<template>
  <div v-if="data" class="m-fast-payment-system">
    <f-sprite-icon
      :icon-link="$options.icons.IconSpb.id"
      class="m-fast-payment-system__spb-icon"
    />

    <div class="m-fast-payment-system__header">
      <div class="m-fast-payment-system__title">
        Выберите банк для подтверждения оплаты
      </div>

      <ui-input
        v-model="query"
        :disabled="loading"
        clearable
        placeholder="Найти банк"
        class="m-fast-payment-system__search"
      />
    </div>

    <ui-loader
      v-if="loading"
      size="64"
      class="m-fast-payment-system__loader"
    />

    <template v-else>
      <div
        v-if="recommendedBanks.length && query.length < 2"
        class="m-fast-payment-system__recommendation"
      >
        <div class="m-fast-payment-system__label">
          Вы выбирали в прошлый раз
        </div>

        <m-fast-payment-system-bank
          v-for="bank of recommendedBanks"
          :key="bank.bankName"
          :bank="bank"
          :qr-url="data.qrUrl"
        />
      </div>

      <div v-if="filteredBanks.length" class="m-fast-payment-system__list">
        <div v-if="recommendedBanks.length" class="m-fast-payment-system__label">
          Все банки
        </div>

        <m-fast-payment-system-bank
          v-for="bank of filteredBanks"
          :key="bank.bankName"
          :bank="bank"
          :qr-url="data.qrUrl"
          @click.native="onSelectBank(bank.bankName)"
        />
      </div>
      <div v-else class="m-fast-payment-system__label">
        По Вашему запросу результатов не найдено
      </div>
    </template>
  </div>
</template>

<script>
import { createPaymentLocalStorage } from '@/services/storage/payment-storage';

import MFastPaymentSystemBank from './m-fast-payment-system-bank.vue';

import IconSpb from '@icons/spb.multi.svg';
import IconArrow from '@icons/arrow-small.svg';

export default {
  name: 'm-fast-payment-system',

  components: {
    MFastPaymentSystemBank,
  },

  icons: {
    IconSpb,
    IconArrow,
  },

  props: {
    data: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    query: '',
    banks: [],
    loading: true,
    selectedBankNames: [],
  }),

  computed: {
    filteredBanks() {
      if (this.query.length < 2) {
        return this.banks.filter(({ bankName }) => !this.selectedBankNames.includes(bankName));
      }
      const regExp = new RegExp(this.query, 'im');
      return this.banks.filter(({ bankName }) => regExp.test(bankName));
    },

    recommendedBanks() {
      if (!this.selectedBankNames.length) return [];
      return this.banks.filter(({ bankName }) => this.selectedBankNames.includes(bankName));
    },

    paymentStorage: () => createPaymentLocalStorage(),
  },

  async mounted() {
    try {
      this.selectedBankNames = this.paymentStorage.fpsSelectedBanks;
      const { dictionary } = await this.$store.$api.getPaymentFpsBanks();
      this.banks = dictionary;
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  },

  methods: {
    onSelectBank(name) {
      this.paymentStorage.addFpsSelectedBank(name);
    }
  },
};
</script>

<style lang="scss">
.m-fast-payment-system {
  &__spb-icon.sprite-icon {
    width: 116px;
    height: 58px;
    margin: 0 auto 26px;
  }

  &__header {
    margin: 0 16px;
  }

  &__title {
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: $black;
  }

  &__search.ui-input {
    min-height: auto;
  }

  &__loader {
    color: $blue;
    margin: 20% auto;
  }

  &__reccomendation {
  }

  &__label {
    display: flex;
    align-items: flex-end;
    margin-top: 16px;
    padding: 0 16px;
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: $gray;
  }
}
</style>
